// extracted by mini-css-extract-plugin
export default {"loading-wrap":"style_loading-wrap__4j4Qf","img-wrap":"style_img-wrap__pgpn0","glow-bg":"style_glow-bg__T+GQ5","pulse":"style_pulse__0kC3T"};